
import React from 'react';
import AddPortfolioModal from '@/components/AddPortfolioModal';
import AddBusinessModal from '@/components/AddBusinessModal';
import MobileAddBusinessModal from '@/components/MobileAddBusinessModal';
import { Portfolio } from '@/schemas/portfolio'; // Updated import
import { PortfolioFormValues } from '@/hooks/useAddPortfolioForm';

interface PortfolioModalsProps {
  showAddPortfolioModal: boolean;
  setShowAddPortfolioModal: (show: boolean) => void;
  showAddBusinessModal: boolean;
  setShowAddBusinessModal: (show: boolean) => void;
  showMobileAddBusinessModal: boolean;
  setShowMobileAddBusinessModal: (show: boolean) => void;
  selectedPortfolioId: string | null;
  getPortfolioNameById: (id: string) => string;
  handlePortfolioSubmit: (formData: PortfolioFormValues) => Promise<string | undefined>;
  handleAddNewPortfolio: () => void;
  handleSelectPortfolio: (portfolioId: string) => void;
  allPortfolios: Portfolio[];
}

const PortfolioModals: React.FC<PortfolioModalsProps> = ({
  showAddPortfolioModal,
  setShowAddPortfolioModal,
  showAddBusinessModal,
  setShowAddBusinessModal,
  showMobileAddBusinessModal,
  setShowMobileAddBusinessModal,
  selectedPortfolioId,
  getPortfolioNameById,
  handlePortfolioSubmit,
  handleAddNewPortfolio,
  handleSelectPortfolio,
  allPortfolios
}) => {
  return (
    <>
      <AddPortfolioModal 
        open={showAddPortfolioModal}
        onOpenChange={setShowAddPortfolioModal}
        onAddPortfolio={handlePortfolioSubmit}
      />
      
      <AddBusinessModal 
        open={showAddBusinessModal}
        onOpenChange={setShowAddBusinessModal}
        portfolioId={selectedPortfolioId || ''}
        portfolioName={selectedPortfolioId ? getPortfolioNameById(selectedPortfolioId) : ''}
      />
      
      <MobileAddBusinessModal
        open={showMobileAddBusinessModal}
        onOpenChange={setShowMobileAddBusinessModal}
        portfolios={allPortfolios}
        onCreateNewPortfolio={handleAddNewPortfolio}
        onSelectPortfolio={handleSelectPortfolio}
      />
    </>
  );
};

export default PortfolioModals;
